module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_20.3fd06191.mp3";